import '../styles/footer.css';
import { webURL } from '../config';

const Footer = () => {
    return (
    <footer className='footer-container'>
      <div className="footer-text">© 2025 Copyright:
            <a href={webURL} target="_blank" style={{ textDecoration: 'none' }} rel="noreferrer">  <span className='footer-text-url' >{webURL}</span></a>
          </div>     
    </footer>
    )
}
export default Footer;